<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/190405-feature-pic.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">樂觀女性生仔機會較大</div>
                   <div class="post_info">Posted at 09:00h in 生育健康</div>
                    <div class="post_tip_1" style="margin-top:0px !important;">
                       專家建議，想生男嬰的女性須保持心境開朗及良好體質。
                    </div>
                    <div class="post_wrapper_1">
                        據統計處估計，在香港男、女出生比率日趨失衡，女多男少情況日趨嚴重，男孩子可能愈來愈矜貴。英國一項研究發現，
                        性格樂觀和生活較輕鬆的女性，懷孕時生男孩的機會較大，建議想生男嬰的女性更要保持心境開朗及良好體格。
                    </div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190405-boy-or-girl.jpg"/>
                    </div>
                    <div class="post_wrapper_tip">與荷爾蒙有關</div>
                    <div class="post_wrapper_1">
                        英國《衞報》昨報道指，這項由英國肯特大學進行的研究發現，該國生活富足及擁有良好體格的女性會較容易生男孩，特別是那些性格樂觀及熱愛生命，並認為自己壽命會較長的女性，她們生男孩的機會率較性格悲觀的女性為高。
                    </div>
                     <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190405-hormones.jpg"/>
                    </div>
                    
                    <div class="post_wrapper_1 margin_top">
                        負責該項研究的生物學家指出，根據進化生物學理論，如果女性的生活條件困難，引致健康欠佳，而且令生活變得緊張又不輕鬆，有關女性較可能生女孩，
                        這反映生活條件貧乏會影響出生嬰身的性別比率。英國利物浦大學的一名進化生物學家認為，部份原因與荷爾蒙有關，但真正原因仍需繼續探討。</div>
                    <div class="post_wrapper_1 margin_top">
                        據馬爾他大學和約翰內斯堡金山大學合作做的一項研究中，發現在2010年南非舉行世界盃這舉國歡樂盛事之後的9個月，
                        南非男嬰的出生率由百分之50.3，微升至百分之50.8，推論出夫婦生活開心，生仔比例愈高。</div>
                        <div class="post_wrapper_1 margin_top">
                        研究同時發現，經歷重大悲劇，例如天災人禍發生後，男嬰出生率亦有明顯下降。統計結果顯示美國911恐怖襲擊事件和日本神戶大地震之後，
                        當地女嬰的出生率會明顯上升（資訊由約翰內斯堡綜合報導提供）。</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190405-bbc-born.jpg"/>
                        <div class="bottom_tip">英國有數據顯示從18世紀至20世紀毎年的男孩出生數字一直都比女孩的高 [1]。</div>
                    </div>
                     <div class="post_wrapper_1 margin_top">
                        有許多不同的因素如父母的年齡，女性的排卵週期，壓力水平，飲食和性行為等都能影響生男或生女的機會。
                        生的是男或是女決定於男性精子（攜帶Y染色體）或女性精子（攜帶X染色體）能首個爭奪與女性的卵子受精 [1]。
                    </div>
                     <div class="post_wrapper_1 margin_top">
                       一個流行的理論是，女性在排卵前幾天連續幾天進行性行為，會較大機會生女。因為女性精子雖然游得比精男性精子慢，
                       但壽命比較男性精子長，當排卵時，卵子會與還生存的女性精子受精，生產出女孩。
                    </div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190405-baby-twins.jpg"/>
                    </div>
                    <div class="post_wrapper_1 margin_top">
                      相反，如果性生活更接近排卵期或之後，男性精子游得比女性精子快，能較大機會搶先進入卵子與卵子受精，生產出男孩 [1]。
                    </div>
                    <div class="post_wrapper_1 margin_top">
                      每個人也應該要有輕鬆的生活和能保持心境開朗及維持健康體格，無論生男生女也好，都應順其自然，要是希望生的是男孩，倒不如希望生的是一個健康的寶寶。
                    </div>
                    <div class="post_wrapper_1">
                        參考資料：<a href="https://www.bbc.com/news/health-46597323">1. Why are more boys than girls born every single year? </a>By Philippa Roxby, Health reporter, BBC News
                    </div>
               </div>
           </div>
          <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
                .margin_top{
                    margin-top:35px;
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/gensfour.vue